// extracted by mini-css-extract-plugin
export default {"projectNameInput":"projectNameInput__eMeMn6"};